import { defineStore } from "pinia";
import { type AgentsDirectoryAutocompleteItem } from "../dto/agents-directory.dto";
import { useAgentsDirectoryApi } from "../http/agents-directory.api";

export const useAgentsDirectoryStore = defineStore("agents-directory", {
  actions: {
    async autocomplete(pattern: string): Promise<AgentsDirectoryAutocompleteItem[]> {
      return useAgentsDirectoryApi().autocomplete(pattern);
    },
  },
});
